// ICS Map Icons - shared across App.js and components
const ICS_ICONS = {
  // Basic Markers
  'default': { label: 'Default Pin', emoji: '\u{1F4CD}', unicode: '\u{1F4CD}' },
  'info': { label: 'Information', emoji: '\u{2139}', unicode: '\u{2139}' },
  'warning': { label: 'Warning', emoji: '\u{26A0}', unicode: '\u{26A0}' },
  'alert': { label: 'Alert', emoji: '\u{1F514}', unicode: '\u{1F514}' },
  
  // Command & Control
  'command': { label: 'Command Post', emoji: '\u{2B50}', unicode: '\u{2B50}' },
  'incident': { label: 'Incident Base', emoji: '\u{1F3E2}', unicode: '\u{1F3E2}' },
  'staging': { label: 'Staging Area', emoji: '\u{1F17F}', unicode: '\u{1F17F}' },
  'operations': { label: 'Operations', emoji: '\u{2699}', unicode: '\u{2699}' },
  
  // Emergency Services
  'fire': { label: 'Fire Station/Unit', emoji: '\u{1F692}', unicode: '\u{1F692}' },
  'police': { label: 'Police', emoji: '\u{1F693}', unicode: '\u{1F693}' },
  'ambulance': { label: 'Ambulance', emoji: '\u{1F691}', unicode: '\u{1F691}' },
  'rescue': { label: 'Search & Rescue', emoji: '\u{26D1}', unicode: '\u{26D1}' },
  
  // Medical & Health
  'medical': { label: 'Medical Facility', emoji: '\u{1F3E5}', unicode: '\u{1F3E5}' },
  'hospital': { label: 'Hospital', emoji: '\u{1F3E5}', unicode: '\u{1F3E5}' },
  'triage': { label: 'Triage Area', emoji: '\u{1FA7A}', unicode: '\u{1FA7A}' },
  'first-aid': { label: 'First Aid', emoji: '\u{1FA79}', unicode: '\u{1FA79}' },
  'pharmacy': { label: 'Pharmacy', emoji: '\u{1F48A}', unicode: '\u{1F48A}' },
  
  // Transportation
  'helicopter': { label: 'Helicopter/Helipad', emoji: '\u{1F681}', unicode: '\u{1F681}' },
  'airport': { label: 'Airport', emoji: '\u{2708}', unicode: '\u{2708}' },
  'boat': { label: 'Marine/Boat', emoji: '\u{1F6A4}', unicode: '\u{1F6A4}' },
  'vehicle': { label: 'Vehicle', emoji: '\u{1F690}', unicode: '\u{1F690}' },
  'truck': { label: 'Truck', emoji: '\u{1F69A}', unicode: '\u{1F69A}' },
  
  // Hazards & Risks
  'hazmat': { label: 'Hazmat', emoji: '\u{2622}', unicode: '\u{2622}' },
  'fire-hazard': { label: 'Fire Hazard', emoji: '\u{1F525}', unicode: '\u{1F525}' },
  'flood': { label: 'Flood Zone', emoji: '\u{1F30A}', unicode: '\u{1F30A}' },
  'lightning': { label: 'Lightning/Storm', emoji: '\u{26A1}', unicode: '\u{26A1}' },
  'tornado': { label: 'Tornado', emoji: '\u{1F32A}', unicode: '\u{1F32A}' },
  'earthquake': { label: 'Earthquake', emoji: '\u{1F3DA}', unicode: '\u{1F3DA}' },
  'landslide': { label: 'Landslide', emoji: '\u{26F0}', unicode: '\u{26F0}' },
  
  // Facilities & Shelters
  'shelter': { label: 'Emergency Shelter', emoji: '\u{1F3E0}', unicode: '\u{1F3E0}' },
  'evacuation': { label: 'Evacuation Center', emoji: '\u{1F3C3}', unicode: '\u{1F3C3}' },
  'school': { label: 'School', emoji: '\u{1F3EB}', unicode: '\u{1F3EB}' },
  'building': { label: 'Building', emoji: '\u{1F3E2}', unicode: '\u{1F3E2}' },
  'tent': { label: 'Tent/Temporary', emoji: '\u{26FA}', unicode: '\u{26FA}' },
  
  // Resources & Supplies
  'supply': { label: 'Supply Point', emoji: '\u{1F4E6}', unicode: '\u{1F4E6}' },
  'food': { label: 'Food Distribution', emoji: '\u{1F37D}', unicode: '\u{1F37D}' },
  'water': { label: 'Water Supply', emoji: '\u{1F4A7}', unicode: '\u{1F4A7}' },
  'fuel': { label: 'Fuel Station', emoji: '\u{26FD}', unicode: '\u{26FD}' },
  'generator': { label: 'Generator/Power', emoji: '\u{1F50C}', unicode: '\u{1F50C}' },
  
  // Safety & Security
  'security': { label: 'Security', emoji: '\u{1F512}', unicode: '\u{1F512}' },
  'checkpoint': { label: 'Checkpoint', emoji: '\u{1F6D1}', unicode: '\u{1F6D1}' },
  'roadblock': { label: 'Road Block', emoji: '\u{1F6A7}', unicode: '\u{1F6A7}' },
  'barrier': { label: 'Barrier', emoji: '\u{1F6A7}', unicode: '\u{1F6A7}' },
  
  // Communications
  'communications': { label: 'Communications', emoji: '\u{1F4E1}', unicode: '\u{1F4E1}' },
  'radio': { label: 'Radio Tower', emoji: '\u{1F4FB}', unicode: '\u{1F4FB}' },
  'phone': { label: 'Phone', emoji: '\u{260E}', unicode: '\u{260E}' },
  'wifi': { label: 'WiFi Point', emoji: '\u{1F4F6}', unicode: '\u{1F4F6}' },
  
  // Personnel & Teams
  'personnel': { label: 'Personnel', emoji: '\u{1F464}', unicode: '\u{1F464}' },
  'team': { label: 'Team', emoji: '\u{1F465}', unicode: '\u{1F465}' },
  'volunteer': { label: 'Volunteers', emoji: '\u{1F64B}', unicode: '\u{1F64B}' },
  
  // Special Operations
  'drone': { label: 'Drone/UAV', emoji: '\u{1F6F8}', unicode: '\u{1F6F8}' },
  'camera': { label: 'Surveillance', emoji: '\u{1F4F9}', unicode: '\u{1F4F9}' },
  'laboratory': { label: 'Laboratory', emoji: '\u{1F52C}', unicode: '\u{1F52C}' },
  'decon': { label: 'Decontamination', emoji: '\u{1F6BF}', unicode: '\u{1F6BF}' },
  
  // Utilities & Infrastructure
  'electrical': { label: 'Electrical', emoji: '\u{26A1}', unicode: '\u{26A1}' },
  'water-utility': { label: 'Water Utility', emoji: '\u{1F6B0}', unicode: '\u{1F6B0}' },
  'bridge': { label: 'Bridge', emoji: '\u{1F309}', unicode: '\u{1F309}' },
  'road': { label: 'Road/Route', emoji: '\u{1F6E3}', unicode: '\u{1F6E3}' },
  
  // Weather & Environment
  'weather': { label: 'Weather Station', emoji: '\u{1F321}', unicode: '\u{1F321}' },
  'wind': { label: 'Wind', emoji: '\u{1F4A8}', unicode: '\u{1F4A8}' },
  'snow': { label: 'Snow', emoji: '\u{2744}', unicode: '\u{2744}' },
  'sun': { label: 'Heat/Sun', emoji: '\u{2600}', unicode: '\u{2600}' },
  
  // Additional Emergency Icons
  'casualties': { label: 'Casualties', emoji: '\u{1F6A8}', unicode: '\u{1F6A8}' },
  'morgue': { label: 'Morgue', emoji: '\u{26B0}', unicode: '\u{26B0}' },
  'pet-shelter': { label: 'Pet Shelter', emoji: '\u{1F415}', unicode: '\u{1F415}' },
  'sanitation': { label: 'Sanitation', emoji: '\u{1F6BD}', unicode: '\u{1F6BD}' },
  'lost-found': { label: 'Lost & Found', emoji: '\u{1F50D}', unicode: '\u{1F50D}' },
  'meeting': { label: 'Meeting Point', emoji: '\u{1F4CD}', unicode: '\u{1F4CD}' }
};

export default ICS_ICONS;
